import { Page } from "@/components/misc";
import { Card } from "@/components/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ActivityIcon, DatabaseIcon, KeyIcon, LayersIcon, TableIcon } from "lucide-react";

export const Route = createFileRoute("/warehouse/")({
  component: WarehouseDashboard,
});

const sections = [
  {
    to: "/warehouse/overview" as const,
    icon: ActivityIcon,
    label: "Overview",
    description: "DAG visualization of the feature store",
  },
  {
    to: "/warehouse/id-types" as const,
    icon: KeyIcon,
    label: "ID Types",
    description: "Entity identifier types used across source tables",
  },
  {
    to: "/warehouse/source-tables" as const,
    icon: TableIcon,
    label: "Source Tables",
    description: "Snowflake table references and column mappings",
  },
  {
    to: "/warehouse/features" as const,
    icon: LayersIcon,
    label: "Features",
    description: "Feature specifications with aggregations and filters",
  },
  {
    to: "/warehouse/metrics" as const,
    icon: DatabaseIcon,
    label: "Metrics",
    description: "Metric definitions for experiments and dashboards",
  },
];

function WarehouseDashboard() {
  return (
    <Page size="large" className="min-w-[48rem] space-y-6">
      <Page.TitleContainer>
        <div>
          <Page.Title>Data Warehouse</Page.Title>
          <Page.Subtitle>
            Feature store metadata, source tables, and metric definitions
          </Page.Subtitle>
        </div>
      </Page.TitleContainer>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {sections.map((section) => (
          <Link key={section.to} to={section.to}>
            <Card className="transition-colors hover:border-primary/50 h-full">
              <Card.Header>
                <div className="flex items-center gap-2">
                  <section.icon className="size-5 text-muted-foreground" />
                  <Card.Title>{section.label}</Card.Title>
                </div>
                <Card.Description>{section.description}</Card.Description>
              </Card.Header>
            </Card>
          </Link>
        ))}
      </div>
    </Page>
  );
}
